export const HEAD_DIVISION_ID = "ac2f9c22-035e-4e57-82ef-2dce5d52f86e";
